import React from "react";
import { useNavigate } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { useAuthState } from "../hooks/useAuth";
import { isEarlyAccess } from "../constants/contentLimits";
import "./Breadcrumbs.css";

const Breadcrumbs = ({ path = [] }) => {
  const navigate = useNavigate();
  const { user } = useAuthState();

  if (path.length === 0) return null;

  const handleClick = (item) => {
    if (item.onClick) {
      item.onClick();
    } else if (item.path) {
      navigate(item.path);
    }
  };

  const isMobile = window.innerWidth <= 1280;

  const truncateLabel = (label, maxLength = 35) => {
    if (!label || !isMobile) return label;
    
    if (React.isValidElement(label)) {
      const textContent = label.props.children?.[1];
      if (typeof textContent === 'string' && textContent.length > maxLength) {
        return React.cloneElement(label, {}, [
          label.props.children[0],
          textContent.substring(0, maxLength) + '...'
        ]);
      }
      return label;
    }
    
    if (typeof label !== 'string') return label;
    if (label.length <= maxLength) return label;
    return label.substring(0, maxLength) + '...';
  };

  // On mobile with 4+ items: show first, "...", second-to-last, last
  const mobilePath = isMobile && path.length >= 4
    ? [path[0], { label: '...', collapsed: true }, path[path.length - 2], path[path.length - 1]]
    : path;

  return (
    <div className="breadcrumbs-container">
      <div className="breadcrumbs-inner">
        <div
          className="breadcrumb-home-icon"
          onClick={() => navigate('/')}
          title="Home"
        >
          A{isEarlyAccess(user) && <span className="breadcrumb-home-plus">+</span>}
        </div>
        <ChevronRight size={16} className="breadcrumb-separator" />
        
        {mobilePath.map((item, index) => (
          <React.Fragment key={index}>
            <span
              className={`breadcrumb-item ${index === mobilePath.length - 1 ? 'active' : ''}${item.hideOnMobile ? ' breadcrumb-hide-mobile' : ''}${index < 2 ? ' breadcrumb-item-fixed' : ''}${item.collapsed || (!item.path && !item.onClick) ? ' breadcrumb-item-static' : ''}`}
              onClick={() => !item.collapsed && handleClick(item)}
              title={item.label}
            >
              {truncateLabel(item.label)}
            </span>
            {index < mobilePath.length - 1 && (
              <ChevronRight size={16} className={`breadcrumb-separator${item.hideOnMobile ? ' breadcrumb-hide-mobile' : ''}`} />
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default Breadcrumbs;
